var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFurnitureServicesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_4857_1719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.7451 6.24835C75.0051 6.24835 94.7451 25.9884 94.7451 50.2484C94.7451 74.5084 75.0051 94.2484 50.7451 94.2484C26.4851 94.2484 6.74515 74.5084 6.74515 50.2484C6.74515 25.9884 26.4851 6.24835 50.7451 6.24835ZM50.7451 0.248352C23.1351 0.248352 0.745148 22.6384 0.745148 50.2484C0.745148 77.8584 23.1351 100.248 50.7451 100.248C78.3551 100.248 100.745 77.8584 100.745 50.2484C100.745 22.6384 78.3551 0.248352 50.7451 0.248352Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7851 18.2084C64.4851 15.7484 57.5851 14.5684 50.7451 14.5284C43.9051 14.5684 37.0051 15.7484 32.7051 18.2084C24.5251 22.8984 24.3551 31.1484 25.4551 39.5784C25.8951 43.0284 26.7251 46.4184 27.4051 49.8184C27.5051 50.0484 29.0551 50.1684 29.4851 50.2684C34.4551 51.5184 36.9551 55.5884 37.5551 60.4784L37.7251 60.6984C41.7751 59.1584 46.2751 58.4484 50.7451 58.4384C55.2151 58.4484 59.7151 59.1584 63.7651 60.6984L63.9351 60.4784C64.5351 55.5884 67.0352 51.5184 72.0051 50.2684C72.4351 50.1684 73.9851 50.0484 74.0851 49.8184C74.7651 46.4184 75.5951 43.0284 76.0351 39.5784C77.1351 31.1484 76.9651 22.8984 68.7851 18.2084ZM45.5751 34.6184C46.1451 35.1884 46.1451 36.1184 45.5751 36.6884C45.0051 37.2584 44.0751 37.2584 43.5051 36.6884L42.5851 35.7584L41.6551 36.6884C41.0851 37.2584 40.1651 37.2584 39.5951 36.6884C39.0251 36.1184 39.0251 35.1884 39.5951 34.6184L40.5151 33.6984L39.5951 32.7784C39.3051 32.4884 39.1651 32.1184 39.1651 31.7484C39.1651 31.3784 39.3051 30.9884 39.5951 30.7084C40.1651 30.1384 41.0851 30.1384 41.6551 30.7084L42.5851 31.6283L43.5051 30.7084C44.0751 30.1384 45.0051 30.1384 45.5751 30.7084C46.1451 31.2784 46.1451 32.2084 45.5751 32.7784L44.6451 33.6984L45.5751 34.6184ZM53.7351 42.4484C54.3051 43.0184 54.3051 43.9484 53.7351 44.5184C53.1651 45.0884 52.2351 45.0884 51.6651 44.5184L50.7451 43.5984L49.8251 44.5184C49.2551 45.0884 48.3251 45.0884 47.7551 44.5184C47.1851 43.9484 47.1851 43.0184 47.7551 42.4484L48.6751 41.5284L47.7551 40.6084C47.4651 40.3284 47.3251 39.9484 47.3251 39.5684C47.3251 39.1884 47.4651 38.8284 47.7551 38.5384C48.3251 37.9684 49.2551 37.9684 49.8251 38.5384L50.7451 39.4684L51.6651 38.5384C52.2351 37.9684 53.1651 37.9684 53.7351 38.5384C54.3051 39.1084 54.3051 40.0384 53.7351 40.6084L52.8151 41.5284L53.7351 42.4484ZM61.8951 34.6184C62.4651 35.1884 62.4651 36.1184 61.8951 36.6884C61.3251 37.2584 60.4051 37.2584 59.8351 36.6884L58.9051 35.7584L57.9851 36.6884C57.4151 37.2584 56.4851 37.2584 55.9151 36.6884C55.3451 36.1184 55.3451 35.1884 55.9151 34.6184L56.8451 33.6984L55.9151 32.7784C55.6251 32.4884 55.4851 32.1184 55.4851 31.7484C55.4851 31.3784 55.6251 30.9884 55.9151 30.7084C56.4851 30.1384 57.4151 30.1384 57.9851 30.7084L58.9051 31.6283L59.8351 30.7084C60.1251 30.4284 60.4951 30.2784 60.8651 30.2784C61.2351 30.2784 61.6051 30.4284 61.8951 30.7084C62.4651 31.2784 62.4651 32.2084 61.8951 32.7784L60.9751 33.6984L61.8951 34.6184Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5651 62.4084L62.6351 69.2383C58.6951 69.8083 54.7251 70.1184 50.7451 70.1384C46.7651 70.1184 42.7951 69.8083 38.8551 69.2383L37.9251 62.4084C42.0051 60.9884 46.3751 60.2684 50.7451 60.2384C55.1151 60.2684 59.4851 60.9884 63.5651 62.4084Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7851 77.4584C74.4151 78.5884 72.5251 79.3884 70.7351 79.5084H30.7551C28.9651 79.3884 27.0751 78.5884 25.7051 77.4584C22.3751 74.6784 18.4951 63.2284 18.8751 58.9484C19.2051 55.1284 22.4351 52.1284 26.1951 51.7984C26.5351 51.7684 26.8751 51.7484 27.1951 51.7484C36.1951 51.7584 36.3751 63.3784 37.0351 70.0784C37.1951 70.6784 37.6551 70.7684 38.1851 70.8984C41.3351 71.6884 45.7751 71.9883 50.1151 71.9883H51.3751C55.7151 71.9883 60.1551 71.6884 63.3051 70.8984C63.8351 70.7684 64.2951 70.6784 64.4551 70.0784C65.1151 63.3784 65.2952 51.7484 74.2952 51.7484C74.6152 51.7484 74.9552 51.7684 75.2952 51.7984C79.0552 52.1284 82.2852 55.1284 82.6152 58.9484C82.9952 63.2284 79.1151 74.6784 75.7851 77.4584Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0251 81.5084V85.3884C38.0251 86.6484 37.0051 87.6784 35.7351 87.6784C34.4751 87.6784 33.4451 86.6584 33.4451 85.3884V81.5084H38.0251Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0251 81.5084V85.3884C68.0251 86.6484 67.0051 87.6784 65.7351 87.6784C64.4751 87.6784 63.4451 86.6584 63.4451 85.3884V81.5084H68.0251Z",
    fill: "#00FFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4857_1719",
    x: 0.0000118613,
    y: -0.0000265539,
    width: 101.49,
    height: 102.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.496757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.372568
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "screen",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4857_1719"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4857_1719",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_4857_1719"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_4857_1719",
    result: "effect3_innerShadow_4857_1719"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurnitureServicesIcon);
export default __webpack_public_path__ + "static/media/FurnitureServicesIcon.5c72c6b45c733d41291575cf0b848999.svg";
export { ForwardRef as ReactComponent };